import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import {
  AllocationActionPrepareCallToDockModel,
  AllocationDetailsModel,
  AllocationManualActionRequestModel,
  AllocationViewSelectedEntityModel,
} from '../../models';
import { AllocationViewActionInterface, AllocationViewCombinedActionInterface } from '../models';

import {
  AllocationViewCallToDockAction,
  AllocationViewCallToDockActionPrepare,
  AllocationViewCallToDockActionAllocateUli,
  AllocationViewCallToDockActionSetInitialState,
  AllocationViewCallToDockDismissConsent,
} from './allocation-view-call-to-dock-action.actions';
import { AllocationViewCallToDockActionState } from './allocation-view-call-to-dock-action.state';
import { NfStatus } from '../../../nota-fiscal/models/nf-status.enum';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToDockActionFacade
  implements AllocationViewActionInterface, AllocationViewCombinedActionInterface
{
  loaded$: Observable<boolean> = this.store.select(AllocationViewCallToDockActionState.getLoaded);

  callToDockDetails$: Observable<AllocationActionPrepareCallToDockModel> = this.store.select(
    AllocationViewCallToDockActionState.getCallToDockDetails,
  );

  allocationDetails$: Observable<AllocationDetailsModel> = this.store.select(
    AllocationViewCallToDockActionState.getAllocationDetails,
  );

  responseData$: Observable<AllocationDetailsModel> = this.store.select(
    AllocationViewCallToDockActionState.getAllocationDetails,
  );

  consentRequired$: Observable<boolean> = this.store.select(AllocationViewCallToDockActionState.getConsentRequired);

  consentNfStatus$: Observable<NfStatus | null> = this.store.select(
    AllocationViewCallToDockActionState.getConsentNfStatus,
  );

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewCallToDockActionSetInitialState());
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewCallToDockActionPrepare({ identifier }));
      });
  }

  callToDock(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewCallToDockAction({ identifier }));
      });
  }

  callToDockWithConsent(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewCallToDockAction({ identifier, nfConsent: true }));
      });
  }

  dismissConsent(): void {
    this.store.dispatch(new AllocationViewCallToDockDismissConsent());
  }

  allocateUli(data: AllocationManualActionRequestModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewCallToDockActionAllocateUli(data));
    });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewCallToDockActionSetInitialState());
  }
}
